// extracted by mini-css-extract-plugin
export default {"root":"IconSuccess_root__PnIby","fillColor":"IconSuccess_fillColor__peM7m"};